module.exports = __webpack_public_path__ + "static/learning-early@large-825d791db9fc78798d2e7c9db9335342.jpg";